<template>
    <CRow>
        <CCol col="12" xl="8">
            <CCard>
                <CCardHeader>
                    <strong>СМС Сервис</strong>
                </CCardHeader>
                <CForm>
                    <CCardBody>
                        <SMSServiceTabLinks />
                        <CRow class="pl-3 pb-3" />
                        <CDataTable
                            hover
                            column-filter
                            sorter
                            :items-per-page="10"
                            :active-page="activePage"
                            :items="items"
                            :fields="fields"
                            :pagination="{ doubleArrows: true, align: 'center' }"
                            @page-change="pageChange"
                        >
                            <template #type="data">
                                <td>
                                    <CBadge
                                        :color="smsLogTypeBagde(data.item.type)"
                                    >&nbsp;{{ smsLogTypeTitle(data.item.type) }}&nbsp;</CBadge
                                    >
                                </td>
                            </template>
                            <template #phone="data">
                                <td>
                                    {{ data.item.phone ? data.item.phone : "" }}
                                </td>
                            </template>
                            <template #created_at="data">
                                <td>
                                    {{ formatDate(data.item.created_at) }}
                                </td>
                            </template>
                            <template #actions="data">
                                <td>
                                    <CButton
                                        @click="showDetailsDialog(data.item.id)"
                                    ><CIcon
                                        :content="$options.icons.cilInfo"
                                    /></CButton>
                                </td>
                            </template>
                        </CDataTable>
                    </CCardBody>
                    <CCardFooter />
                </CForm>
            </CCard>
        </CCol>

        <CModal
            title="Информация"
            color="info"
            :show.sync="showDetails"
            :footer="false"
            size="lg"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CRow>
                        <CCol sm="4" class="form-group">ID</CCol>
                        <CCol sm="8" class="form-group">#{{ logDetails.id }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Телефон</CCol>
                        <CCol sm="8" class="form-group">{{
                            logDetails.phone ? logDetails.phone : ""
                        }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Тип</CCol>
                        <CCol
                            sm="8"
                            class="form-group"
                        ><CBadge
                            :color="smsLogTypeBagde(logDetails.type)"
                        >&nbsp;{{ smsLogTypeTitle(logDetails.type) }}&nbsp;</CBadge
                        ></CCol
                        >
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Дата</CCol>
                        <CCol sm="8" class="form-group">{{
                            formatDate(logDetails.created_at)
                        }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Отправка</CCol>
                        <CCol sm="8" class="form-group">
                            <pre>{{ logDetailsCode(logDetails.input) }}</pre>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Ответ</CCol>
                        <CCol sm="8" class="form-group">
                            <pre>{{ logDetailsCode(logDetails.output) }}</pre>
                        </CCol>
                    </CRow>
                    <CRow
                        v-for="(hook, index) in logHooks(logDetails.hooks)"
                        :key="'hook-' + index"
                    >
                        <CCol sm="4" class="form-group">Хук {{ hook.event || 'mango' }}</CCol>
                        <CCol sm="8" class="form-group">
                            <pre>{{ formatHook(hook) }}</pre>
                        </CCol>
                    </CRow>
                </div>
                <div slot="footer"></div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import SMSServiceTabLinks from '@/components/SMSServiceTabLinks';
    const { formatDate } = require('../../../utils/views');
    import { cilInfo } from '@coreui/icons';

    export default {
        name: 'SMSServiceLogs',

        components: {
            SMSServiceTabLinks,
        },

        data() {
            return {
                fields: [
                    { key: 'type', label: 'Тип' },
                    { key: 'phone', label: 'Телефон' },
                    { key: 'created_at', label: 'Дата' },
                    { key: 'actions', label: 'Действия' },
                ],
                items: [],
                logDetails: {},
                showDetails: false,
                activePage: 1,
            };
        },

        watch: {
            $route: {
                immediate: true,
                handler(route) {
                    if (route.query && route.query.page) {
                        this.activePage = Number(route.query.page);
                    }
                },
            },
        },

        mounted() {
            Vue.axios
                .get('/services/sms/logs')
                .then(resp => {
                    this.items = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        icons: {
            cilInfo,
        },

        methods: {
            showDetailsDialog(logId) {
                for (var i = 0; i < this.items.length; i++) {
                    if (logId === this.items[i].id) {
                        this.logDetails = this.items[i];
                    }
                }
                this.showDetails = true;
            },
            smsLogTypeTitle(type) {
                return type === 1 ? 'Аутентификация' : 'Сообщение';
            },
            smsLogTypeBagde(type) {
                return type === 1 ? 'secondary' : 'primary';
            },
            formatDate(date) {
                return formatDate(date);
            },
            logDetailsCode(details) {
                var code = details;
                if (details) {
                    try {
                        const detailsObj = JSON.parse(details);
                        if (detailsObj.body) {
                            detailsObj.body = JSON.parse(detailsObj.body);
                        }
                        code = JSON.stringify(detailsObj, null, 4);
                    } catch (err) {
                        // Nothing to do
                    }
                }
                return code;
            },
            logHooks(hooks) {
                if (!hooks) {
                    return [];
                }
                try {
                    const parsed = typeof hooks === 'string' ? JSON.parse(hooks) : hooks;
                    if (Array.isArray(parsed)) {
                        return parsed;
                    }
                    if (parsed && typeof parsed === 'object') {
                        return [parsed];
                    }
                } catch (err) {
                    return [];
                }
                return [];
            },
            formatHook(hook) {
                try {
                    return JSON.stringify(hook, null, 4);
                } catch (err) {
                    return hook;
                }
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
        },
    };
</script>
